import { render, staticRenderFns } from "./CopyAdditionalValuesModal.vue?vue&type=template&id=1fa948b2&scoped=true&lang=html&"
import script from "./CopyAdditionalValuesModal.vue?vue&type=script&lang=js&"
export * from "./CopyAdditionalValuesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa948b2",
  null
  
)

export default component.exports